import { NgModule } from '@angular/core';
import { BasketPassiveComponent } from '~shared/svgs/basket-passive/basket-passive.component';


@NgModule({
  declarations: [
    BasketPassiveComponent
  ],
  exports: [
    BasketPassiveComponent
  ]
})
export class BasketPassiveModule {}
